import React from 'react';

class ReportModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.upLoadImg = this.upLoadImg.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.state = {
            txtValue1: "",
            txtValue2: "",
            reportImage: "",
            clientEmail: [],
            email: "",
            warningMsg: "",
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {
        if (this.props.clientEmail) {
            if (this.props.clientEmail.length > 0) {
                this.setState({
                    clientEmail: this.props.clientEmail
                });
            }
        }
    }
    componentWillUnmount() {

    }
    upLoadImg(e) {
        e.preventDefault();
        let len = e.target.files.length;
        if (len > 3) {
            return this.setState({ warningMsg: "Maximum upload 3 pictures only" });
        } else {
            this.setState({ warningMsg: "" });
        }
        for (let i = 0; i < len; i++) {
            let file = e.target.files[i];
            this._previewImage(file, i);
        }
        //let file = e.target.files[0];
        //this._previewImage(file, 0);
    }
    _previewImage(file, index) {

        //to be modified
        let fr = new FileReader();
        fr.onload = (e) => {
            let imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
            let img = new Image();

            img.onload = () => {
                this.resizeImage(img, index);
            }

            img.src = imgUrl;
        }
        fr.readAsArrayBuffer(file);
    }
    dataURItoBlob(dataURI) {
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = window.atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }
    resizeImage(image, index) {
        let oHeight = image.naturalHeight;
        let oWidth = image.naturalWidth;
        let newImage, newSize;
        let oSize = { oHeight: oHeight, oWidth: oWidth };
        newSize = { width: 500, height: 500 * oHeight / oWidth };

        newImage = this._imgResize(image, newSize, oSize);
        let blobFile = this.state.reportImage;
        if (blobFile == "") blobFile = [];
        blobFile[index] = this.dataURItoBlob(newImage);
        this.setState({ reportImage: blobFile });
    }
    _imgResize(img, newSize, oSize) {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext("2d");
        canvas.width = newSize.width;
        canvas.height = newSize.height;
        ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
        return canvas.toDataURL('image/jpeg', 1);

    }
    handleRemove(e) {
        e.preventDefault();
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        let clientEmail = this.state.clientEmail;
        clientEmail.splice(index, 1);
        this.setState({ clientEmail: clientEmail });
    }
    handleClick(e) {
        let clientEmail = this.state.clientEmail;
        clientEmail = clientEmail.concat(this.state.email);
        this.setState({ clientEmail: clientEmail, email: "" });
    }
    handleEmailChange(e) {
        let value = e.target.value;
        this.setState({ email: value });
    }
    handleChange(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let value = e.target.value;
        if (index == 0) {
            if (this.props.action == 0) {
                value = parseInt(value);
            }
            this.setState({ txtValue1: value });
        } else {
            this.setState({ txtValue2: value });
        }
    }
    handleSubmit(e) {
        if(this.state.reportImage){
            if(this.state.reportImage.length >3){
                return this.setState({warningMsg:"Maximum 3 picture only"});
            }
        }
        if(this.state.txtValue1 == ""){
            return this.setState({warningMsg:"Please fill up all information"});
        }
        if(this.props.action == 0 && this.state.txtValue2 == ""){
            return this.setState({warningMsg:"Please fill up all information"});
        }
        this.props.callBack(this.state.txtValue1, this.state.txtValue2, this.state.clientEmail, this.state.reportImage);
    }

    modalClose() {
        this.props.shouldModalClose(false);
    }
    renderEmailList() {
        return this.state.clientEmail.map((email, index) => {
            return (
                <div className="rp-em" key={index}>
                    <div className="rp-em-1">{email}</div>
                    <button className="rp-em-2 btn btn-xs btn-danger" data-index={index} onClick={this.handleRemove}>Remove</button>
                </div>
            );
        });
    }
    renderEmail() {
        return (
            <form autoComplete="on" style={{ marginTop: "10px" }}>
                <div className="input-group" style={{ marginBottom: "10px" }}>
                    <input type="text" className="form-control" placeholder="Email" value={this.state.email}
                        onChange={this.handleEmailChange} autoComplete="on" />
                    <span className="input-group-btn">
                        <button className="btn btn-default" type="button" onClick={this.handleClick}>Add</button>
                    </span>
                </div>
                <label>Recipients</label>
                {this.renderEmailList()}
            </form>
        );
    }
    renderBody() {
        let body = "";
        if (this.props.action == 0) {
            body = (
                <div>
                    <form>
                        <input className="form-control" placeholder="Extend no of days" type="number" data-index="0"
                            onChange={this.handleChange} />
                        <textarea className="form-control" rows="3" placeholder="Input reason here" type="text" data-index="1"
                            onChange={this.handleChange} />
                        <input className="form-control" type="file" name="myImage" accept="image/x-png,image/jpeg"
                            onChange={this.upLoadImg} multiple />
                    </form>
                    {this.renderEmail()}
                </div>
            );
        } else if (this.props.action == 1) {
            body = (
                <div>
                    <form>
                        <textarea className="form-control" rows="3" placeholder="Input resolution here" type="text" data-index="0"
                            onChange={this.handleChange} />
                        <input className="form-control" type="file" name="myImage" accept="image/x-png,image/jpeg"
                            onChange={this.upLoadImg} multiple />
                    </form>
                    {this.renderEmail()}
                </div>
            );
        } else if (this.props.action == 2) {
            body = (
                <div>
                    <form>
                        <textarea className="form-control" rows="3" placeholder="Add remark here" type="text" data-index="0"
                            onChange={this.handleChange} />
                        <input className="form-control" type="file" name="myImage" accept="image/x-png,image/jpeg"
                            onChange={this.upLoadImg} multiple />
                    </form>
                    {this.renderEmail()}
                </div>
            );
        } else {
            //remove incident report
            body = (
                <div>
                    <form>
                        <textarea className="form-control" rows="3" placeholder="Input reason to remove incident report" type="text" data-index="0"
                            onChange={this.handleChange} />
                    </form>
                    {this.renderEmail()}
                </div>
            );
        }
        return (body);
    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        let content;

        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title" >{this.props.title}</h4>
                    </div>

                    <div className="modal-body" >
                        <div className="warning">
                            {this.state.warningMsg}
                        </div>
                        {this.renderBody()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className={"btn " + (this.props.action == 3 ? " btn-danger" : "btn-warning")}
                            onClick={this.handleSubmit}>
                            {this.props.action == 3 ? "Remove" : "Update"}
                        </button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default ReportModal;


// WEBPACK FOOTER //
// ./app/components/reportComponents/reportModal.js